import {useMemo} from "react";
import {sanitizeHtml} from "./sanitizeHtml";

// Displays HTML from RichTextEditor (or older plain text), sanitized.
export function RichText({html, className = ''}: { html: string, className?: string }) {
    const safe = useMemo(() => sanitizeHtml(html), [html]);
    return <div className={`rich-text ${className}`} dangerouslySetInnerHTML={{ __html: safe }}/>;
}
